import { createContext } from "react";
import {
  ChatContextProps,
  ChatInitialState,
} from "../interfaces/chat.interface";
import { ConversationType } from "../constants/chat.constant";

/**
 * Initial state for the ChatContext.
 * Provides default values for chat-related global state including conversations,
 * selected conversation, loading states, and conversation type.
 */
export const CHAT_INITIAL_STATE: ChatInitialState = {
  conversations: [],
  conversationStatusMap: new Map(),
  selectedConversation: {
    session_id: "",
    title: "",
    conversation_type: ConversationType.CHOP_GPT,
  },
  isLoading: false,
  isResponseGenerating: false,
  conversationType: ConversationType.CHOP_GPT,
  isLoadingHistory: false,
  content: "",
  refetchFolders: () => {},
};

/**
 * ChatContext provides global chat state management throughout the application.
 * Contains conversations list, selected conversation, loading states, content,
 * and dispatch function for state updates.
 * 
 * @context
 * @example
 * ```tsx
 * const { state, dispatch } = useContext(ChatContext);
 * 
 * dispatch({ field: 'selectedConversation', value: conversation });
 * ```
 */
export const ChatContext = createContext<ChatContextProps>(undefined!);
